import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Para qué edad es recomendable este programa?',
    answer: 'Enfoque de Acero está diseñado específicamente para jóvenes de 10 a 18 años. Los ejercicios son adaptables según la madurez del estudiante, pero el núcleo del sistema funciona mejor en este rango de edad donde se están formando los hábitos de estudio.'
  }, {
    question: '¿Cuánto tiempo diario requiere?',
    answer: 'El protocolo está diseñado para no interferir con la escuela. Requiere aproximadamente 15-20 minutos al día: 5 minutos de preparación por la mañana y 10-15 minutos de ejercicios o reflexión por la tarde.'
  }, {
    question: '¿Necesito supervisar a mi hijo todo el tiempo?',
    answer: "No. El objetivo es desarrollar autonomía. Sin embargo, recomendamos que los padres lean la 'Guía para Mentores' incluida para saber cómo apoyar el proceso sin micro-gestionar."
  }, {
    question: '¿Qué pasa si no vemos resultados?',
    answer: 'Ofrecemos una garantía de satisfacción total de 30 días. Si aplicas el protocolo y no ves una mejora en la concentración y organización de tu hijo, te devolvemos el 100% de tu dinero sin preguntas.'
  }];
  return <section className="py-20 bg-white" data-id="element-1">
      
    </section>;
}